import React from 'react';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const pains = ['No sabés si una falla es grave o puede esperar', 'Escuchás ruidos raros y no sabés qué significan', 'Sentís desconfianza cada vez que vas al taller', 'Cambiás cosas “por las dudas”', 'Gastás sin entender realmente por qué'];
  return <section className="bg-gray-50 py-16 px-4" data-id="element-72">
      <div className="max-w-3xl mx-auto" data-id="element-73">
        <div className="text-center mb-12" data-id="element-74">
          <p className="text-lg font-semibold text-gray-500 uppercase mb-2" data-id="element-75">
            Si tenés un auto, dejame hacerte una pregunta honesta
          </p>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 leading-tight" data-id="element-76">
            ¿Te pasa que llevar el auto al taller te genera más{' '}
            <span className="text-red-600 bg-red-100 px-2" data-id="element-77">estrés</span> que
            tranquilidad?
          </h2>
        </div>

        <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-200 mb-12" data-id="element-78">
          <p className="text-lg text-gray-700 mb-6" data-id="element-79">
            No porque seas descuidado. No porque no te importe tu vehículo.
            <br data-id="element-80" />
            <br data-id="element-81" />
            Sino porque{' '}
            <span className="font-bold" data-id="element-82">
              nadie te enseñó cómo cuidarlo de forma simple y preventiva.
            </span>
          </p>
          <p className="text-lg text-gray-700 italic border-l-4 border-red-500 pl-4 py-2 bg-red-50 mb-6" data-id="element-83">
            Vas por un detalle chico… Salís con una factura enorme. Escuchás
            palabras que no entendés. Aceptás por miedo a romper algo peor.
          </p>
          <p className="text-xl font-bold text-center text-gray-800" data-id="element-84">
            Y te vas pensando: “Ojalá supiera un poco más…”
          </p>
        </div>

        <div className="space-y-8" data-id="element-85">
          <div className="text-center" data-id="element-86">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-87">
              Cuidar un auto no debería sentirse así
            </h3>
            <p className="text-lg text-gray-700" data-id="element-88">
              El problema que nadie dice en voz alta es este:
              <br data-id="element-89" />
              <span className="font-bold bg-yellow-100 px-1" data-id="element-90">
                👉 No gastás de más por fallas reales, sino por desconocimiento.
              </span>
            </p>
          </div>

          <div className="bg-white p-6 md:p-8 rounded-xl shadow-md" data-id="element-91">
            <h4 className="font-bold text-gray-900 mb-6 text-lg" data-id="element-92">
              Si tenés auto, esto seguro te resulta familiar:
            </h4>
            <ul className="space-y-4" data-id="element-93">
              {pains.map((pain, index) => <li key={index} className="flex items-start gap-3" data-id="element-94">
                  <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-95" />
                  <span className="text-lg text-gray-700" data-id="element-96">{pain}</span>
                </li>)}
            </ul>
            <div className="mt-8 p-4 bg-red-50 rounded-lg text-center border border-red-100" data-id="element-97">
              <p className="font-bold text-red-800 text-lg" data-id="element-98">
                Lo peor no es el dinero. Es la sensación constante de no tener
                control.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}